<template>
  <div>
    <mt-header title="预约信息">
      <router-link to="/mine" slot="left">返回</router-link>
    </mt-header>

    <div class="exp-wrap">
      <div class="exp-head">
        <div>当前状态:{{curStatus}}</div>
        <div>验证码:{{dataObj.pass_key}}</div>
      </div>
      <appoint-info v-if="dataObj" :dataObj="dataObj"></appoint-info>
      <div class="btn-wrap">
        <div class="btn" @click="cancelHandle">
          <p>撤销预约</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { myorderdetail, cancel } from "@/api/api";
import {
  formatDate,
  formatStartTimeTips,
  formatEndTimeTips,
  allTime,
} from "@/utils/util";
import { Toast, Indicator } from "mint-ui";
import appointInfo from "@/components/appointInfo";
export default {
  data() {
    return {
      dataObj: "",
      curStatus: "",
      statusList: [
        {
          status: 1,
          value: "使用中",
        },
        {
          status: 0,
          value: "待体验",
        },
        {
          status: 2,
          value: "已逾期",
        },
        {
          status: 3,
          value: "已取消",
        },
        {
          status: 4,
          value: "已完成",
        },
      ],
    };
  },
  components: {
    appointInfo,
  },
  mounted() {
    let log_id = this.$route.query.logId;
    myorderdetail({
      log_id,
    }).then((res) => {
      this.dataObj = res;
      this.dataObj["date"] = formatDate(this.dataObj.day);
      this.dataObj["startTime"] = formatStartTimeTips(this.dataObj.start_time);
      this.dataObj["endTime"] = formatEndTimeTips(this.dataObj.end_time);
      this.dataObj["allTime"] = allTime(
        this.dataObj.start_time,
        this.dataObj.end_time
      );
      this.statusList.forEach((item) => {
        if (item.status == this.dataObj.status) {
          this.curStatus = item.value;
        }
      });
    });
  },
  methods: {
    cancelHandle() {
      this.$messagebox({
        title: "提示",
        message: "是否撤销预约",
        confirmButtonText: "确定",
      }).then((action) => {
        if (action == "confirm") {
          cancel({
            log_id: this.$route.query.logId,
          }).then((res) => {
            console.log(res, "resss");
            Toast("撤销成功");
            setTimeout(() => {
              this.$router.replace("/mine");
            }, 200);
          });
        } else {
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.mint-msgbox-wrapper {
  font-size: 1rem !important;
}
.exp-wrap {
  width: 100vw;

  .exp-head {
    padding: 20px;
    font-size: 0.45rem;
    display: flex;
    justify-content: space-between;
  }
  .exp-info-wrap {
    padding: 20px;
    font-size: 0.35rem;
    color: #fff;
    .exp-info {
      background-color: #006feb;
      padding: 40px;
      border-radius: 20px;
      .info-item {
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .btn-wrap {
    width: 100%;
    display: flex;
    margin-top: 60px;
    justify-content: space-around;
    .btn {
      background-color: #006feb;
      color: #fff;
      border-radius: 10px;
      padding: 20px 200px;
      font-size: 0.35rem;
    }
  }
}
</style>